export default function Brand({ variant = 'sidebar' }) {
  return (
    <div className={`brand brand--${variant}`}>
      <div className="brand__identity">
        <img
          className="brand__logo"
          src="/images/sharjah-family-development-mark.png"
          alt=""
          aria-hidden="true"
        />
        <span className="brand__name">Sharjah Family Development</span>
      </div>
      <span className="brand__subtitle">Operational Plans &amp; Performance</span>
    </div>
  );
}
